<template>
  <FastQuote/>
</template>

<script>
import FastQuote from '@/components/fast-quote/FastQuote.vue'

export default {

  name: 'Create',
  components: {
      FastQuote
  },
  mounted() {

  }
}
</script>

<style>

</style>